<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="titlepageImage">
<p class="centerImage"><img alt="images" id="titlepage" src="images/titlepage.jpg" style="max-width: 100%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_ThenandNowbook_titlepage.vue?df2d25b8